import {
  PAGE_CHANGE,
  SEARCH_CHANGE,
  FILTER_CHANGE,
  type AdminActionType,
} from 'containers/admin/actions';

/**
 * Minimum state contract for `usersReducer`. Both fields are optional so
 * concrete consumers can declare narrower shapes (e.g. `{ search: string }`
 * for HeroLearn, `{ pageIndex: number }` for ReportsTab) while still
 * satisfying the constraint. The runtime semantics are unchanged from the
 * legacy JS: every action returns `{ ...state, ... }` so any extra fields
 * the caller's state carries are preserved.
 */
export type AdminUsersStateBase = {
  search?: string;
  pageIndex?: number;
};

export type AdminUsersAction = {
  type: AdminActionType;
  payload?: unknown;
};

export const usersReducer = <T extends AdminUsersStateBase>(
  state: T,
  action: AdminUsersAction
): T => {
  switch (action.type) {
    case PAGE_CHANGE:
      return {
        ...state,
        pageIndex: action.payload as number,
      } as T;

    case SEARCH_CHANGE:
      return {
        ...state,
        search: action.payload as string,
        pageIndex: 0,
      } as T;

    case FILTER_CHANGE:
      return {
        ...state,
        pageIndex: 0,
      } as T;

    default:
      return state;
  }
};
